export default "__VITE_ASSET__74vGc_7I__"